import { AxiosConfigAuthentication } from "LandingPage/Config/AxiosConfig";

export const resetPassword = (data, callback) => {
  const axios = AxiosConfigAuthentication();
  const url = `/user/reset_password`;
  axios
    .post(url, data)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      callback(err.response.data);
      // callback({ data: err.response?.data, status: "ERROR" });
    });
};
